module.exports = __webpack_public_path__ + "img/license-radio-on.5dd5a58b.svg";